// extracted by mini-css-extract-plugin
module.exports = {"qrcode":"qr-code_qrcode__3dpSW","downloadbutton":"qr-code_downloadbutton__3kz1c"};